import {
    INextStep,
    IPreviousStep,
    IGoToStep,
    IResetSubSteps,
} from '../actions/step';

const initialState = {
    main: 1,
    instructions: 1,
    visualAcuity: 1,
    astigmatism: 1,
    macularDegeneration: 1,
    backgroundQuestions: 1,
};

export const step = (
    state = initialState,
    action: INextStep | IPreviousStep | IGoToStep | IResetSubSteps
) => {
    switch (action.type) {
        case 'STEP_NEXT':
            return {
                ...state,
                [action.payload]: state[action.payload] + 1,
            };
        case 'STEP_PREVIOUS':
            return {
                ...state,
                [action.payload]: state[action.payload] - 1,
            };
        case 'STEP_GO_TO':
            return {
                ...state,
                [action.counter]: action.stepNumber,
            };
        case 'STEP_RESET_SUBSTEPS':
            return {
                ...initialState,
                main: state.main,
            };
        default:
            return state;
    }
};
